import fp from 'lodash/fp';
import { pageLayouts, pageSizes } from '../../constants';

const tableMargin = 20;
const rowHeight = 27;

const tableRow = ({ rowLines = 1, bold, columns, text: rowText, ...row }, tableWidth, y) => {
  const totalColSpan = fp.sumBy(({ colSpan = 1 }) => colSpan)(columns);
  const columnWidth = tableWidth / totalColSpan;

  return fp.reduce(
    ({ columnIndex, value }, { colSpan = 1, text: columnText, ...column }) => {
      const x = tableMargin + (columnWidth * columnIndex);

      const text = {
        ...rowText,
        ...(
          typeof (columnText) === 'string' ?
            { value: columnText } :
            columnText
        )
      };

      const {
        colour: textColour = '#666666',
        font = bold ? 'Helvetica-Bold' : 'Helvetica',
        fontSize = 8,
        offsetY: textOffsetY = (10 - (5 * (rowLines - 1))),
        value: textValue
      } = text;

      const {
        colour
      } = {
        ...row,
        ...column
      };

      return {
        columnIndex: columnIndex + colSpan,
        value: fp.concat(
          value,
          [
            ['rect', [x, y, columnWidth * colSpan, rowHeight * rowLines]],
            ['fill', [colour]],
            ['fontSize', [fontSize]],
            ['font', [font]],
            ['fillColour', [textColour]],
            ['text', [textValue, x + 10, y + textOffsetY, {
              width: columnWidth * colSpan,
              height: rowHeight * rowLines - textOffsetY,
              align: 'left'
            }]],
          ]
        )
      };
    },
    {
      columnIndex: 0,
      value: []
    }
  )(columns).value;
};

const table = ({ pageLayout, pageSize, remainingPageHeight, reportHeader, headerRow, rows }) => {
  const tableWidth = 842 - (tableMargin * 2);
  const pageHeight = fp.get(
    `${pageSize || 'A4'}.${pageLayout === pageLayouts.landscape ? 'x' : 'y'}`
  )(pageSizes);

  return [
    ['save'],
    ...fp.reduce(
      ({ index, onAdditionalPage, value: lastValue }, row) => {
        const y = tableMargin + (rowHeight * index);
        const addPage = onAdditionalPage ?
          y + rowHeight > pageHeight - tableMargin :
          y + rowHeight > remainingPageHeight - tableMargin;
        const value = addPage ?
          fp.concat(lastValue, [
            ['addPage'],
            ...reportHeader,
            ...tableRow(headerRow, tableWidth, addPage ? tableMargin : y)
          ]) :
          lastValue;

        return {
          index: addPage ? 2 : index + 1,
          onAdditionalPage: onAdditionalPage || addPage,
          value: fp.concat(value, [...tableRow(row, tableWidth, addPage ? tableMargin + rowHeight : y)])
        };
      },
      {
        index: 0,
        onAdditionalPage: false,
        value: []
      }
    )(fp.concat([headerRow], rows)).value,
    ['fill', ['#1fd1a1']],
    ['restore']
  ];
};

export default table;



// WEBPACK FOOTER //
// ./src/reports/partials/table.js